import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { useSnackbar } from "src/utils/useSnackbar";
import { useTranslation } from "react-i18next";
import { getOneActionPlanKey } from "./useGetOneActionPlan";
import { getAllActionPlanKey } from "./useGetAllActionPlan";
import { getAllActionPlanActionsKey } from "../ActionPlanAction/useGetAllActionPlanAction";

export const useRecreateActionPlan = (actionPlanID: string) => {
    const snackbar = useSnackbar();
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    const query = useMutation({
        mutationFn: async (_?: unknown) => {
            snackbar.forceClose();
            snackbar.setSnackbarProps({
                type: "info",
                message: t("action_plan.snackbar.recreating", "Action plan is recreating."),
                forceAutoHideInMilisecond: null,
            });

            const url = `/api/action_plans/${actionPlanID}/recreate`;
            return loggedInApiCall.post(
                url,
                {},
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                },
            );
        },
        onSuccess: async () => {
            await Promise.all([
                queryClient.refetchQueries([getOneActionPlanKey]),
                queryClient.refetchQueries([getAllActionPlanKey]),
                queryClient.refetchQueries([getAllActionPlanActionsKey]),
            ]);

            snackbar.forceClose();
            snackbar.setSnackbarProps({
                type: "success",
                message: t("action_plan.snackbar.recreate_success", "Action plan recreation successful."),
            });
        },
        onError: () => {
            snackbar.forceClose();
            snackbar.setSnackbarProps({
                type: "error",
                message: t(
                    "action_plan.snackbar.recreate_error",
                    "Action plan recreation failed, please contact your administrator.",
                ),
            });
        },
    });

    return query;
};
